export const maxRows = 8;
export const allowedLetters = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
export enum State {
    ABSENT = '#808080', PRESENT = '#bea70e', CORRECT = '#3db43d'
}